<template>
  <div class="main-readOlny" v-if="dialogShow">
    <div draggable="true" class="headerBox" @dragend="drag" cursor="hand">
      <span>{{ header ? $t(header) : $t('variavel-manipulada') }}</span>
    </div>
    <div class="body">
      <!-- INPUTS -->
      <div @keyup.enter="SaveNode" @keyup.esc="Cancel">
        <span v-if="inputType.inputBox">
          <label for="type ">{{$t('desiredValue')}}</label>
          <input
            ref="input"
            class="input-vazao"
            v-model="value"
            type="number"
          />
        </span>
      </div>

      <div @keyup.enter="SaveNode" @keyup.esc="Cancel">
        <span v-if="inputType.inputSlider">
          <span class="input-manual">
            <label for="type ">{{$t('desiredDeviation')}}</label>
            <span>
              <input ref="input" v-model.number="value" type="number" />%
            </span>
          </span>
          <b-input-group prepend="0" append="100" class="mt-3">
            <b-form-input
              class="input-pentagro"
              v-model.number="value"
              type="range"
              step="0.01"
              min="0"
              max="100"
            />
          </b-input-group>
        </span>
      </div>

      <div @keyup.enter="SaveNode" @keyup.esc="Cancel" v-if="inputType.milling" >
        <div>
          <label>{{$t('bagasseMoisture')}}</label>
          <b-input
            class="input-pentagro"
            ref="input"
            type="number"
            v-model="attributeDictionary['umidadeC6'].value"
          />
        </div>

        <div>
          <label>{{$t('soakingFiber')}}</label>
          <b-input
            class="input-pentagro"
            type="number"
            v-model="attributeDictionary['tx_agua'].value"
          />
        </div>

        <div>
          <label>{{$t('soakingTemperature')}}</label>
          <b-input
            class="input-pentagro"
            type="number"
            v-model="attributeDictionary['T'].value"
          />
        </div>

        <p>{{$t('occupationDialog')}} {{ attributeDictionary["Ocupacao"].value }} %</p>
        <p>
          {{$t('extractionEfficiency')}}
          {{ attributeDictionary["eficienciaExtracao"].value }} %
        </p>
      </div>
      <!-- /INPUTS -->

      <!-- NÓS -->
      <FormBomb
        v-if="node.type == types.Bomb"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormBoiler
        v-if="node.type == types.Boiler"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormHeater
        v-if="node.type == types.Heater"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormCargoLoss
        v-if="node.type == types.CargoLoss"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormMilling2
        v-if="node.type == types.Milling"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormContinuousDorna
        v-if="node.type == types.ContinuousDorna"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormDistillationColumnA
        v-if="node.type == types.DistillationColumnA"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormVat
        v-if="node.type == types.Vat"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormEthanolCentrifuge
        v-if="node.type == types.EthanolCentrifuge"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormDesuperheater
        v-if="node.type == types.Desuperheater"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormFlotador
        v-if="node.type == types.Flotador"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormDeaerator
        v-if="node.type == types.Deaerator"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormCurrent
        v-if="node.type == types.Current"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormFermentationBatch
        v-if="node.type == types.FermentationBatch"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <DistillationColumnB
        v-if="node.type == types.DistillationColumnB"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormEnergyDemand
        v-if="node.type == types.EnergyDemand"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormTurbine
        v-if="node.type == types.Turbine"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormDiffuser
        v-if="node.type == types.Diffuser"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormSprayDryer
        v-if="node.type == types.SprayDryer"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormSugarCooker
        v-if="node.type == types.SugarCooker"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormRegeneratorD
        v-if="node.type == types.RegeneratorD"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormEvaporator
        v-if="node.type == types.Evaporator"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormFilter3
        v-if="node.type == types.Filter3"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormFilterPress
        v-if="node.type == types.FilterPress"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormCondenser
        v-if="node.type == types.Condenser"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormDecanter
        v-if="node.type == types.Decanter"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormCoolingTower
        v-if="node.type == types.CoolingTower"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormInputCana
        v-if="node.type == types.InputCana"
        :node.sync="nodeEdited"
        :readOnly="true"
        :importONLS=importData
      />
      <FormMultipleInput
        v-if="node.type == types.MultipleInput"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormEvaporativeCondenser
        v-if="node.type == types.EvaporativeCondenser"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormLiming
        v-if="node.type == types.Liming"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormDistillationColumn2
        v-if="node.type == types.DistillationColumn2"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormDryer
        v-if="node.type == types.Dryer"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormStrainer
        v-if="node.type == types.Strainer"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormSugarCookerContinuous
        v-if="node.type == types.SugarCookerContinuous"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormSugarCentrifugue
        v-if="node.type == types.SugarCentrifugue"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormSugarCentrifugueBatch
        v-if="node.type == types.SugarCentrifugueBatch"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormEvaporator2
        v-if="node.type == types.Evaporator2"
        :node.sync="nodeEdited"
        :readOnly="true"
      />
      <FormInputCorn
        v-if="node.type == types.InputCorn"
        :node.sync="nodeEdited"
        :readOnly="true"
        :importONLS=importDataCorn
      />
      <FormCitrus
        v-if="node.type == types.Citrus"
        :node.sync="nodeEdited"
        :readOnly="true"
        :importONLS=importDataCitrus
      />
      <!--/ NÓS -->
    </div>
    <div @keyup.enter="SaveNode" @keyup.esc="Cancel" class="footer">
      <img
        v-if="node.type == types.InputCana || node.type == types.InputCorn  || node.type == types.Citrus"
        src="@/assets/importar.png"
        style="margin: 0 8px 0 10px;  width: 30px; cursor: pointer"
        title="Importar dados do online"
        alt="Importar dados do online"
        @click="importDataCane(node.type)"
      />
      <b-button variant="danger" @click="Cancel">{{$t('cancel')}}</b-button>
      <b-button variant="success" @click="SaveNode">{{$t('ok')}}</b-button>
    </div>
  </div>
</template>
<script>
import { NumberFormat, ParseToNumber } from "./utils/tools"
import FormBomb from "./nodes/bomb/FormBomb.vue";
import FormBoiler from "./nodes/boiler/FormBoiler.vue";
import FormHeater from "./nodes/heater/FormHeater.vue";
import FormCargoLoss from "./nodes/cargoLoss/FormCargoLoss.vue";
import FormMilling2 from "./nodes/milling/FormMilling2"; 
import FormContinuousDorna from "./nodes/continuousDorna/FormContinuousDorna";
import FormDistillationColumnA from "./nodes/distillationColumnA/FormDistillationColumnA"; 
import FormVat from "./nodes/vat/FormVat"; 
import FormEthanolCentrifuge from "./nodes/ethanolCentrifuge/FormEthanolCentrifuge"; 
import FormDesuperheater from "./nodes/desuperheater/FormDesuperheater"; 
import FormFlotador from "./nodes/flotador/FormFlotador"; 
import FormDeaerator from "./nodes/deaerator/FormDeaerator"; 
import FormCurrent from "./nodes/current/FormCurrent"; 
import FormFermentationBatch from "./nodes/FermentationBatch/FormFermentationBatch"; 
import DistillationColumnB from "./nodes/distillationColumnB/DistillationColumnB"; 
import FormEnergyDemand from "./nodes/energyDemand/FormEnergyDemand"; 
import FormTurbine from "./nodes/turbine/FormTurbine"; 
import FormDiffuser from "./nodes/diffuser/FormDiffuser"; 
import FormSprayDryer from "./nodes/sprayDryer/FormSprayDryer"; 
import FormSugarCooker from "./nodes/sugarCooker/FormSugarCooker"; 
import FormRegeneratorD from "./nodes/regeneratorD/FormRegeneratorD"; 
import FormEvaporator from "./nodes/evaporator/FormEvaporator"; 
import FormFilter3 from "./nodes/filter3/FormFilter3"; 
import FormDecanter from "./nodes/decanter/FormDecanter"; 
import FormCoolingTower from "./nodes/coolingTower/FormCoolingTower"; 
import FormInputCana from "./nodes/inputCana/FormInputCana"; 
import FormMultipleInput from "./nodes/multipleInput/FormMultipleInput"; 
import FormEvaporativeCondenser from "./nodes/evaporativeCondenser/FormEvaporativeCondenser"; 
import FormLiming from "./nodes/liming/FormLiming";
import FormDistillationColumn2 from "./nodes/distillationColumn2/FormDistillationColumn2";
import FormDryer from "./nodes/dryer/FormDryer";
import FormStrainer from "./nodes/strainer/FormStrainer";
import FormSugarCookerContinuous from "./nodes/sugarCookerContinuous/FormSugarCookerContinuous";
import FormSugarCentrifugue from "./nodes/sugarCentrifugue/FormSugarCentrifugue";
import FormSugarCentrifugueBatch from "./nodes/sugarCentrifugueBatch/FormSugarCentrifugueBatch";
import FormEvaporator2 from "./nodes/evaporator2/FormEvaporator2";
import FormFilterPress from "./nodes/filterPress/FormFilterPress";
import FormCondenser from "./nodes/condenser/FormCondenser";
import FormInputCorn from "./nodes/inputCorn/FormInputCorn.vue";
import FormCitrus from "./nodes/citrus/FormCitrus.vue";
import { Types } from "./utils/nodeTypes";
import { DragMixin } from "../mixins/dragMixin"
import { SingletonAreas } from './nodes/_service/singletonAreas';
import { urlMainAPI, showError } from "@/global";
import { SingletonFlowchart } from "./nodes/_service/singletonFlowchart";
import axios from 'axios'

  export default {
    name:"DialogReadOnly",
    provide(){
      return {
        cancelForm: this.Cancel,
        saveForm : this.SaveNode
      }
    },
    components: {
      FormBomb,
      FormBoiler,
      FormHeater,
      FormCargoLoss,
      FormMilling2,
      FormContinuousDorna,
      FormDistillationColumnA,
      FormVat,
      FormEthanolCentrifuge,
      FormDesuperheater,
      FormFlotador,
      FormDeaerator,
      FormCurrent,
      FormFermentationBatch,
      DistillationColumnB,
      FormEnergyDemand,
      FormTurbine,
      FormDiffuser,
      FormSprayDryer,
      FormSugarCooker,
      FormRegeneratorD,
      FormEvaporator,
      FormFilter3,
      FormDecanter,
      FormCoolingTower,
      FormInputCana,
      FormMultipleInput,
      FormEvaporativeCondenser,
      FormLiming,
      FormDistillationColumn2,
      FormDryer,
      FormStrainer,
      FormSugarCookerContinuous,
      FormSugarCentrifugue,
      FormSugarCentrifugueBatch,
      FormEvaporator2,
      FormFilterPress,
      FormCondenser,
      FormInputCorn,
      FormCitrus
    },

    props: {
      node: {
        type: Object,
        default: null,
      },
      dialogVisibleShow: {
        type: Number,
        default: 0,
      },
      types:{
        type: Object,
        required: true
      }
    },

    mixins: [ DragMixin ],

    data: function() {
      return {
        nodeEdited : {},
        header: null,
        dialogShow: false,
        value: 0.00,
        inputType: { },
        importData: 0,
        importDataCorn: 0,
        importDataCitrus: 0,
        attributeDictionary: [],
        percentageProperty: ["fracaoMassica", "brix", "brixSaida", "Saida", "brixAcucar", "brixMel", "tx_agua", "artTorta", "pureza", "purAcucar", "purMel", "xSolidosNaoFibraTorta", "TR", "f_C", "P_FT", "X", "eficienciaSeparacao", "K", "RecuperacaoEtanol", "xflegmaca", "xhidratado", "fmEtanol", "Tx_L", "umidadeC6", "vmC"],
        uniqueInputList: [new Types().Input ]
      };
    },

    watch: {
      async dialogVisibleShow(){
        this.header = new Types().Caption[this.node.type];
        this.nodeEdited = this.node.clone()
        
        if(!this.nodeEdited.data || this.nodeEdited.data.length == 1 && this.nodeEdited.data[0].key == "") return;
        
        this.setInputForm()
        this.dialogShow = true;
        this.$nextTick(function () {
          this.$refs.input && this.$refs.input.focus();
        });

        setTimeout(this.resizeDialog, 100)
      },
    },

    methods: {
      setInputForm(){
        if(this.uniqueInputList.includes(this.nodeEdited.type)){
          let prop = this.nodeEdited.data[0]
          let isvmCTon = prop.key == "vmC" && this.nodeEdited.isvmCTon

          if(prop){
            this.value = parseFloat(prop.value.replace(".", "").replace(",", "."));
  
            if(this.percentageProperty.includes(prop.key) && !isvmCTon){
              this.inputType = { inputSlider: true }
              return
            }
          }

          this.inputType = { inputBox: true }
          return
        }
        
        this.inputType = { inputBox: false }
      },

      async SaveNode() {
        if (this.nodeEdited.idName.includes("Citrus")) 
        {
          let data = this.nodeEdited.attrs;

          let sumProp_mp1 = 0;
          let sumProp_mp2 = 0;
          let sumProp_mp3 = 0;
          let sumPropT1 = 0;
          let sumPropT2 = 0;
          let sumPropT3 = 0;

          let shouldPass = true;

          let type1 = 'T1';
          let type2 = 'T2';
          let type3 = 'T3';

          data.forEach(item => {
            if (item.mapping.includes('tipo_produto')) 
            {
              //NFC
              if (ParseToNumber(NumberFormat(item.value)) == 1 && type1 == 'T1') 
              {
                type1 = item.index  
              }
              //FCOJ
              if (ParseToNumber(NumberFormat(item.value)) == 2 && type2 == 'T2') 
              {
                type2 = item.index  
              }
              //RFA
              if (ParseToNumber(NumberFormat(item.value)) == 3 && type3 == 'T3') 
              {
                type3 = item.index  
              }
            }
          });
          
          data.forEach(item => {
            if (item.mapping.includes('fm_mp1') && (item.mapping.includes(type1))) 
            {
              sumProp_mp1 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp2') && (item.mapping.includes(type1))) 
            {
              sumProp_mp2 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp3') && (item.mapping.includes(type1))) 
            {
              sumProp_mp3 = ParseToNumber(NumberFormat(item.value));
            }
          });

          sumPropT1 = sumProp_mp1 + sumProp_mp2 + sumProp_mp3

          data.forEach(item => {
            if (item.mapping.includes('fm_mp1') && (item.mapping.includes(type2))) 
            {
              sumProp_mp1 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp2') && (item.mapping.includes(type2))) 
            {
              sumProp_mp2 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp3') && (item.mapping.includes(type2))) 
            {
              sumProp_mp3 = ParseToNumber(NumberFormat(item.value));
            }
          });

          sumPropT2 = sumProp_mp1 + sumProp_mp2 + sumProp_mp3 

          data.forEach(item => {
            if (item.mapping.includes('fm_mp1') && (item.mapping.includes(type3))) 
            {
              sumProp_mp1 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp2') && (item.mapping.includes(type3))) 
            {
              sumProp_mp2 = ParseToNumber(NumberFormat(item.value));
            }
            if (item.mapping.includes('fm_mp3') && (item.mapping.includes(type3))) 
            {
              sumProp_mp3 = ParseToNumber(NumberFormat(item.value));
            }
          });

          sumPropT3 = sumProp_mp1 + sumProp_mp2 + sumProp_mp3 
          
          let sumNFC = (sumPropT1 > 99 && sumPropT1 < 101) ? true : false;
          let sumFCOJ = (sumPropT2 > 99 && sumPropT2 < 101) ? true : false;
          let sumRFA = (sumPropT3 > 99 && sumPropT3 < 101) ? true : false;
          
          if (!sumNFC && sumPropT1 != 0)
          {
            showError(this.$t('naoatingiu-100-prop-nfc'))
            shouldPass = false;
          }

          if (!sumFCOJ && sumPropT2 != 0)
          {
            showError(this.$t('naoatingiu-100-prop-fcoj'))
            shouldPass = false;
          }

          if (!sumRFA && sumPropT3 != 0)
          {
            showError(this.$t('naoatingiu-100-prop-rfa'))
            shouldPass = false;
          } 

          if (shouldPass) 
          {
            
            this.saveValue()
            this.node.update(this.nodeEdited)
            SingletonAreas.SaveJoker(this.nodeEdited);
            SingletonAreas.SaveStatus();
            this.dialogShow = false;
            
            this.saveCurrentFlowchart();
          }
        } else 
        {
          console.log('Salvando nó :>> ', this.node);

          this.saveValue()
          this.node.update(this.nodeEdited);
          SingletonAreas.SaveJoker(this.nodeEdited);
          SingletonAreas.SaveStatus();
          this.dialogShow = false;
        }
      },

      async saveCurrentFlowchart() {
        let nodes = SingletonFlowchart.Memory.getNodesToSave();
        let width = document.querySelector("#canvas").clientWidth
        let transform = document.querySelector('#board').getAttribute('transform')

        let flowchart = {
          id: 0,
          area: SingletonAreas.currentArea,
          configuration: JSON.stringify(nodes),
          transform: transform + ` width(${width})`,
          type: 'PAP'
        };

        if (this.saveFlowchart(flowchart)) {
          SingletonFlowchart.wasModified = false;
        }
      },

      async saveFlowchart(flowchart) {
        let success = false;
        const url = `${urlMainAPI}/saveflowchart/PAP`;

        await axios.post(url, flowchart)
          .then((res) => {
            if (res.status == 200)
              flowchart.id = res.data.id
            success = true;
            SingletonAreas.UpdateArea(flowchart)
          })
          .catch(e => console.log(e));

        return success;
      },

      saveValue(){
        if(this.uniqueInputList.includes(this.nodeEdited.type)){
          let prop = this.nodeEdited.data[0]
          prop.value = NumberFormat(this.value);
          this.nodeEdited.attrs = [prop]
        }
      },

      Cancel() {
        this.dialogShow = false;
      },

      resizeDialog(){
        let el = document.querySelector(".main-readOlny")
        if(el){
          el.style.display = "grid";
          el.style.left = `calc(50% - ${(el.clientWidth / 2)}px)`
          el.style.top = `calc(50% - ${(el.clientHeight / 2)}px)`
          el.style['transition-duration'] = "100ms";
        }
      },

      configDragble(){
        this.classToDrag = ".main-readOlny";
        this.fixMouseY = -160
        this.limitTop= -100
        this.limitBotom= 40
        this.limitRight= 0
        this.limitLeft= 0
      },

      importDataCane(typesFunc) 
      {
        if (typesFunc == this.types.Citrus) 
        {
          this.importDataCitrus++
        }
        if (typesFunc == this.types.InputCorn) 
        {
          this.importDataCorn++ 
        } else 
        {
          this.importData++ 
        }
      },
    }, 

    mounted() {
      this.configDragble()
    },
  };
</script>

<style scoped>
.main-readOlny {
  display: none;

  position: absolute;
  top: calc(50% -150px);
  left: calc(50% - 150px);
  min-width: 300px;
  background-color: rgb(250, 250, 250);

  border-radius: 5px;
  box-shadow: 2px 2px 1px #d3d3d3;
  border: 1px solid #d3d3d3;
  font-size: 0.9rem;
  z-index: 10;
}

.headerBox:hover {
  cursor: all-scroll;
}

.title {
  margin: 0;
  display: flex;
  justify-content: space-between;
}

.title > label {
  margin-right: 10px;
}

.confTitle {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-items: flex-end;
}

.input-manual {
  display: flex;
  align-items: flex-start;
}

.input-manual > span > input,
.input-vazao {
  width: 125px;
  font-size: 1rem;
  padding: 3px;
  border: none;
  border-bottom: 1px solid #ced4da;
  margin: 0 10px 0 10px;
}

.input-vazao {
  width: 169px;
}

input:focus {
  outline: 0;
  border-radius: 5px;
  border: 2px solid rgb(103, 163, 216);
  box-shadow: 0 1px 3px rgb(103, 163, 216);
}

.form-control {
  display: block;
  width: 100%;
  height: 30px;
  margin-bottom: 10px;
  padding: 0px;
}

.operation-form {
  display: flex;
  flex-direction: column;
}

.value-operation {
  display: flex;
  justify-content: center;
  margin: 15px 0 0 0;
  width: 100%;
}

.value-operation > input {
  margin: 0 0 0 15px;
  text-align: center;
  border-radius: 5px;
}

.footer {
  padding: 10px;
  text-align: right;
}

.footer > button {
  margin-left: 10px;
}

.body {
  padding: 10px;
  width: 100%;
}

.headerBox {
  padding: 10px;
  border-bottom: 1px solid #d3d3d3;
  font-weight: 700;
  color: #4448;
}
</style>